import { render } from "./Dash.vue?vue&type=template&id=0b36dd36&scoped=true&ts=true"
import script from "./Dash.vue?vue&type=script&lang=ts"
export * from "./Dash.vue?vue&type=script&lang=ts"

import "./Dash.vue?vue&type=style&index=0&id=0b36dd36&lang=css"
import "./Dash.vue?vue&type=style&index=1&id=0b36dd36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b36dd36"]])

export default __exports__